<template>
    <div name="challenge" class="challenge" v-if="result === 0">
        <img v-if="tab === 0" class="image" src="../../assets/showcase/xi/challenge/tab1.png" />
        <div class="tab-button1" @click="tabButton1">

        </div>
        <img v-if="tab === 1" @click="tabButton2" class="image" src="../../assets/showcase/xi/challenge/tab2.png" />
        <div class="tab-button2" @click="tabButton2">

        </div>
        <div  v-if="tab == 0" style="margin-bottom: calc(100vw * 120 / 375); width: 100%;">
            <img class="image" src="../../assets/showcase/xi/challenge/challenge1.png" />
        </div>
        <div v-else class="challenge">
            <img class="image" src="../../assets/showcase/xi/challenge/1.png" />
            <img class="image" src="../../assets/showcase/xi/challenge/2.png" @click="resultChange(3)"/>
            <img class="image" src="../../assets/showcase/xi/challenge/3.png" />
            <img class="image" @click="useLottery" src="../../assets/showcase/xi/challenge/4.png" />
            <img class="image" src="../../assets/showcase/xi/challenge/5.png" @click="resultChange(4)"/>
            <img class="image" src="../../assets/showcase/xi/challenge/6.png" />
            <img class="image" src="../../assets/showcase/xi/challenge/7.png" />
        </div>
    </div>
    <div v-else-if="result === 1" class="challenge">
        <img class="image" src="../../assets/showcase/xi/challenge/result1.png" @click="back" />
        <img class="image" src="../../assets/showcase/xi/challenge/result2.png" @click="resultChange(2)"/>
        <img class="image" src="../../assets/showcase/xi/challenge/result3.png" />
        <!-- <img class="image"  style="position: fixed; bottom: 8vh; width: 100%;" src="../../assets/showcase/xi/challenge/result4.png" /> -->
    </div>
     <div v-else-if="result === 2" class="challenge">
        <img class="image" src="../../assets/showcase/xi/challenge/r1.png" @click="back" />
        <img class="image" src="../../assets/showcase/xi/challenge/r2.png" />
        <img class="image" src="../../assets/showcase/xi/challenge/r3.png" />
        <!-- <img class="image"  style="position: fixed; bottom: 8vh; width: 100%;" src="../../assets/showcase/xi/challenge/result4.png" /> -->
    </div>
    <div v-else-if="result === 3" class="challenge">
        <img class="image" src="../../assets/showcase/xi/challenge/l1.png" @click="back" />
        <img class="image" src="../../assets/showcase/xi/challenge/l2.png" />
    </div>
    <div v-else-if="result === 4" class="challenge">
        <img class="image" src="../../assets/showcase/xi/challenge/ll1.png" @click="back" />
        <img class="image" src="../../assets/showcase/xi/challenge/ll2.png" @click="resultChange(5)"/>
        <img class="image" src="../../assets/showcase/xi/challenge/ll3.png" />
    </div>
    <div v-else-if="result === 5" class="challenge">
        <img class="image" src="../../assets/showcase/xi/challenge/w1.png" @click="back" />
        <img class="image" src="../../assets/showcase/xi/challenge/w2.png" @click="resultChange(4)"/>
        <img class="image" src="../../assets/showcase/xi/challenge/w3.png" />
    </div>
</template>

<script>
export default {
    name: 'challenge',
    data: function()
    {
        return {
            tab: 0,
            result: 0
        }
    },
    methods: {
        tabButton1: function()
        {
            this.tab = 1;
            this.reset();
        },
        tabButton2: function()
        {
            this.tab = 0;
            this.reset();
        },
        useLottery: function()
        {
            this.result = 1;
            this.reset();
        },
        back: function()
        {
            this.result = 0
            this.reset();
        },
        resultChange: function(result)
        {
            this.result = result;
            this.reset();
        },
        reset: function()
        {
            this.$emit('resetCount')
        }
    }
}
</script>

<style scoped>
    .challenge {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .image {
        width: 100%;
    }
    .tab-button1 {
        width: 12vw;
        height: 12vw;
        position: absolute;
        top: 0;
        left: 18vw;
    }
    .tab-button2 {
        width: 12vw;
        height: 12vw;
        position: absolute;
        top: 0;
        left: 2vw;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/Challenge.vue